"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOctokit = void 0;
var rest_1 = require("@octokit/rest");
function createOctokit(params) {
    var _a;
    var octokit = new rest_1.Octokit({ "auth": (_a = params === null || params === void 0 ? void 0 : params.github_token) !== null && _a !== void 0 ? _a : process.env["GITHUB_TOKEN"] });
    return { octokit: octokit };
}
exports.createOctokit = createOctokit;
//# sourceMappingURL=createOctokit.js.map